{
    "version": 1,
    "updatedAt": "2026-09-04T00:00:00Z",
    "general": {
        "email": "info@basisprague.cz",
        "phone": "+420734878769",
        "website": {
            "label": "www.basisprague.cz",
            "url": "https://www.basisprague.cz"
        }
    },
    "campuses": [
        {
            "id": "preschool",
            "name": { "en": "Preschool", "cs": "Školka" },
            "address": "Nad\u00A0Tejnkou\u00A0391/10, Praha\u00A06\u00A0Břevnov, 169\u00A000",
            "officeHours": "9:00–16:00",
            "imageUrl": "/c/3dfa215eb62b85d86162f2c9206913ea/campuses/preschool-brevnov.jpg",
            "website": {
                "url": "https://www.basisprague.cz/preschool"
            },
            "groups": [
                {
                    "title": { "en": "Operations", "cs": "Provoz" },
                    "people": [
                        {
                            "name": "Kateřina Salačová",
                            "phone": "+420728885175",
                            "email": "katerina.salacova@basisprague.cz"
                        }
                    ]
                }
            ]
        },
        {
            "id": "elementary-bubenec",
            "name": {
                "en": "Elementary, Middle & High School",
                "cs": "Základní a střední škola"
            },
            "address": "U\u00A0Vorlíků\u00A0623/4, Praha\u00A06\u00A0Bubeneč, 160\u00A000",
            "officeHours": "9:00–16:00",
            "imageUrl": "/c/3dfa215eb62b85d86162f2c9206913ea/campuses/elementary-bubenec.jpg",
            "website": {
                "url": "https://www.basisprague.cz/middle-school-highschool"
            },
            "groups": [
                {
                    "title": { "en": "Reception", "cs": "Recepce" },
                    "people": [
                        {
                            "name": "Reception",
                            "phone": "+420603885267",
                            "email": "reception@basisprague.cz"
                        }
                    ]
                },
                {
                    "title": { "en": "Operations", "cs": "Provoz" },
                    "people": [
                        {
                            "name": "Jana Környeiová",
                            "phone": "+420603192864",
                            "email": "info@basisprague.cz"
                        }
                    ]
                }
            ]
        }
    ]
}
